export const sources = {
	webp: "__VITE_ASSET__rUkiH63qcJGEQEedyX41xw__ 500w, __VITE_ASSET__6bp_5It$EfTQ8f$omStdjw__ 800w, __VITE_ASSET__kSHvwCjLFxLpY3FM1MyAsA__ 1024w"
};
export const img = {
	src: "__VITE_ASSET__kSHvwCjLFxLpY3FM1MyAsA__",
	w: 1024,
	h: 512
};
export default {
	sources: sources,
	img: img
};
